import React from "react";
import { Layout } from "antd";
import PlayerTeamsTNav from "./PlayerTeamsTNav";

import { Outlet } from "react-router-dom";
const { Content } = Layout;
const PlayerTeamsTLayout = () => {
  return (
    <Layout>
      <div className="profile-header">
        <div className="layout-width">
          <PlayerTeamsTNav />
        </div>
      </div>
      <Content className="layout-width">
        <Outlet />
      </Content>
      {/* <Footer style={{ backgroundColor: "#2F89FC" }}>
        <HomeFooter />
      </Footer> */}
    </Layout>
  );
};
export default PlayerTeamsTLayout;
